'use client';

import type { ReactNode } from 'react';

import { useIsHamburgerMenuEnabled } from './HamburgerMenu/useIsHamburgerMenuEnabled';
import { LayoutHeaderLinksHolder } from './LayoutHeader.styled';

type Props = {
  hideMobileHeaderOnScroll: boolean;
  /**
   * The dropdowns are passed as children so they stay server-rendered:
   * this wrapper only exists to read the Hamburger Menu gate
   */
  children: ReactNode;
};

/**
 * Header Links row. When the hamburger menu is enabled it replaces the row
 * at mdDown, so the row is hidden there
 */
export function LayoutHeaderLinks({
  hideMobileHeaderOnScroll,
  children,
}: Props) {
  const hiddenOnMobile = useIsHamburgerMenuEnabled();

  return (
    <LayoutHeaderLinksHolder
      $hideMobileHeaderOnScroll={hideMobileHeaderOnScroll}
      // NOTE: attribute used in theme-global.css to control the root padding
      data-hidden-on-mobile={hiddenOnMobile || undefined}
      data-qa-id="page-header-links"
    >
      {children}
    </LayoutHeaderLinksHolder>
  );
}
